import AppForm from '../app-components/Form/AppForm';

Vue.component('office-setting-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                app_offices_id:  '' ,
                
            },
            office_selected: ''
        }
    },
    methods:{
        onSelect(appFactory) {
            if (appFactory !== null) {
                this.form.app_offices_id = appFactory.id;
            }else{
                this.form.app_offices_id = null;
            }
        },
        onRemove(appFactory) {
            this.form.app_offices_id = null;
        },
    },
    props: {
        appOffices: {
            type: Array,
            default: ()=>[]
        }
    },
    mounted: function () {  
        // this.office_selected = this.appOffice
    }
});